export default function App() {
  return (
    <main className="shell" style={{ width: "min(650px, calc(100vw - 56px))" }}>
      <header>
        <div className="hero-copy">
          <p className="eyebrow" style={{ mixBlendMode: "hard-light" }}>risk · reliability</p>
          <h1>FuzzyBit</h1>
          <p className="lede">Probabilistic inference, at scale.</p>
          <div style={{ display: "flex", gap: "1rem" }}>
            <a href="https://github.com/fuzzybit-org" rel="noopener noreferrer">
              GitHub
            </a>
            <a href="mailto:info@fuzzybit.org">
              Contact
            </a>
          </div>
        </div>
      </header>
    </main>
  );
}
